/**
 * 用户环境探测（UA 解析）
 * 投放落地页常需按环境分流：微信内引导外部打开、iOS/Android 走不同下载包。
 */

function ua(): string {
  return typeof navigator !== "undefined" ? navigator.userAgent : ""
}

export function isWechat(): boolean {
  return /MicroMessenger/i.test(ua())
}

export function isIOS(): boolean {
  return /iPhone|iPad|iPod|iOS/i.test(ua())
}

export function isAndroid(): boolean {
  return /Android/i.test(ua())
}

export function isMobile(): boolean {
  return isIOS() || isAndroid()
}

export function isWeibo(): boolean {
  return /Weibo/i.test(ua())
}
